import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map} from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { StatePersistService } from '../services/state-persist.service';
import { AuthLoginService } from '../../user/services/auth-login.service';


@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {

    private refreshTokenInProgress = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    constructor(
        private router: Router,
        private stateService: StatePersistService,
        private AuthloginService: AuthLoginService
    ) { }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        if (this.isTokenExpired && httpRequest.url.indexOf('login') === -1
    && httpRequest.url.indexOf('api/v3/o/token') === -1 && httpRequest.url.indexOf('refresh-token') === -1){
      if (!this.refreshTokenInProgress){
        this.refreshTokenInProgress = true;
        this.refreshTokenSubject.next(null);
        let user_details = this.stateService.getLocalStorage('currentUser') || '';
        if(user_details && !user_details?.tokens?.refresh_token){
          return this.AuthloginService.getAuthRefToken().pipe(switchMap((data:any) => {
    
              if(data.status == 200){
       
                data.response.access_token = user_details?.access_token;
                user_details.tokens = data.response;
                this.stateService.setLocalStorage('currentUser', user_details, 'user_update');
              }
 
             this.refreshTokenInProgress = false;
             this.refreshTokenSubject.next(user_details.tokens.access_token); 
             
              return this.handleHttpRequest(httpRequest, next);
         }))


        }else{
          return this.AuthloginService.authToken(true).pipe(switchMap((data:any) => {

            if(user_details && user_details?.tokens?.refresh_token){
               this.updateLoginDetails(data);
            }else{
               this.updateToken(data); 
            }
 
             this.refreshTokenInProgress = false;
             this.refreshTokenSubject.next(data.access_token); 
 
             return this.handleHttpRequest(httpRequest, next);
         }))

        }

      }
      else {
        return this.refreshTokenSubject.pipe(
          filter(d => d != null),
          take(1),
          switchMap(token => {
            return this.handleHttpRequest(httpRequest, next);
          }));
        }
      }
    else{
      return this.handleHttpRequest(httpRequest, next);
    }
    
    
    }

    private handleHttpRequest(httpRequest: HttpRequest<any>, next: HttpHandler) {
        return next.handle(httpRequest).pipe(
          map((event: HttpEvent<any>) => {
               if (event instanceof HttpResponse && event.body.status === 401) {
                 localStorage.clear()
                   this.router.navigate(['/']); 
               }
               if (event instanceof HttpResponse && event?.body?.status === 302) {
                this.router.navigate(['/404']);
            }
               return event;
               
           }),
           catchError((error: any) => {
               if(error.error.status == 401){
                 localStorage.clear()
                 this.router.navigate(['/'])
               }
               return throwError(error);
           }));
    }

    private updateToken(data) {
        if (data.access_token && data.refresh_token) {
            const currentUser = this.stateService.getLocalStorage('user_access_token') || '';
            currentUser.access_token = data.access_token;
            currentUser.refresh_token = data.refresh_token;
            
            let tokenDate = new Date();
            tokenDate.setSeconds(tokenDate.getSeconds() + data?.expires_in); //adding the expiry time in current time.
            tokenDate = new Date((tokenDate).setDate((tokenDate).getDate() - 2));//subtracting the 2 day from token date 
            currentUser.expires_in = tokenDate;
            this.stateService.setLocalStorage('user_access_token', JSON.stringify(currentUser));
          }
    }

    private updateLoginDetails(data:any):void{
        if (data.access_token && data.refresh_token) {
          let user_details = this.stateService.getLocalStorage('currentUser') || '';
           
            let tokenDate = new Date();
            tokenDate.setSeconds(tokenDate.getSeconds() + data?.expires_in); //adding the expiry time in current time.
            tokenDate = new Date((tokenDate).setDate((tokenDate).getDate()));//subtracting the 2 day from token date 
          data.expires_on = tokenDate;
  
          user_details.tokens = data;
          this.stateService.setLocalStorage('currentUser', user_details, 'user_update');
        }
      }
    
    private get isTokenExpired(): boolean {
        const {access_token,expires_in} = JSON.parse(this.stateService.getLocalStorage('user_access_token')) || '';
        const {tokens,id:logged_in_user} = this.stateService.getLocalStorage('currentUser') || '';
    
      
        let token_expiry_date:any = new Date(tokens?.expires_on);

        token_expiry_date = (token_expiry_date).setDate((token_expiry_date).getDate() - 2);
        if(logged_in_user){
    
          if(!tokens?.expires_on){
            return true;
          }else if(tokens?.expires_on){
            if(new Date(token_expiry_date)  < new Date()){
              return true;
            }else{
              return false;
            }
    
          }
    
          return false;
        }else{

          if (!access_token || !expires_in) {
             return false; }
          if (expires_in <  new Date()){
            return true;
        }else{
          return false;
        }
      
        }
    
      }

    
}

